/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./components/redux/store";
import { Toaster } from "react-hot-toast";

const App = lazy(() => import("./App"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Suspense
    fallback={
      <main className="flex flex-col justify-center items-center h-screen">
        {/* <CircularProgress className='text_darkprimary' size={40} thickness={2} /> */}
        <div className="spinner-grow text_primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        {/* <img style={{ width: '2rem', height: "auto" }} src={finabeesingle} className='absolute' alt="" /> */}
      </main>
    }
  >
    <React.StrictMode>
      <Provider store={store}>
        <HashRouter>
          <App />
          <Toaster position="top-center" />
        </HashRouter>
      </Provider>
    </React.StrictMode>
  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
